import { IInProcessSwap } from './in-process-swap';

export interface IDisplaySetting extends IInProcessSwap {
    color: string,
    show: boolean
}